import React from 'react';
import cx from 'classnames';
import { SvgTreeNodeData } from '@mutiny-pkg/champaign-schemas/src/schemas/flexiblePages/flexiblePagesTreeNode';
import { transformToContainerQueries } from '../utils/transformBreakpointClasses';

export const Svg = React.forwardRef<
  SVGSVGElement,
  SvgTreeNodeData & { id: string; editorClassName?: string; isEditor?: boolean }
>(({ id, className, editorClassName, svg, viewBox = '0 0 24 24', isEditor = false, ...props }, ref) => {
  return (
    <svg
      id={id}
      ref={ref}
      className={cx(transformToContainerQueries(className, { isEditor }), editorClassName)}
      viewBox={viewBox}
      dangerouslySetInnerHTML={{ __html: svg }}
      {...props}
    />
  );
});

Svg.displayName = 'Svg';
